/* Internal transform object for the WebGL and Static viewers */
/* Depends on sylvester */

function Sculpteo3DViewerCommonTransform3D(array) {
  if (typeof array == "string") {
    array = eval("([" + array + "])");
  }

  if (typeof array != "undefined" && typeof array.length != "undefined") {
    if (typeof array[0].length != "undefined") {
      array = $M(array).ensure4x4();
    } else {
      array = Matrix.unflatten4x4(array).transpose();
    }
  }

  var matrix = array || Matrix.I(4);

  this.matrix = matrix;
}

Sculpteo3DViewerCommonTransform3D.prototype.toString = function () {
  return this.matrix.transpose().flatten().toString();
};

Sculpteo3DViewerCommonTransform3D.prototype.toArray = function () {
  return this.matrix.transpose().flatten();
};

Sculpteo3DViewerCommonTransform3D.prototype.toRenderString = function () {
  var els = this.matrix.elements;

  return [
    els[0].join(":"),
    els[1].join(":"),
    els[2].join(":"),
    els[3].join(":"),
  ].join(":");
};

Sculpteo3DViewerCommonTransform3D.prototype.translate = function (x, y, z) {
  var M = Matrix.Translation($V([x, y, z])).ensure4x4();

  return new Sculpteo3DViewerCommonTransform3D(M.x(this.matrix));
};

Sculpteo3DViewerCommonTransform3D.prototype.scale = function (x, y, z) {
  var M = Matrix.Diagonal([x, y, z, 1]).ensure4x4();

  return new Sculpteo3DViewerCommonTransform3D(M.x(this.matrix));
};

Sculpteo3DViewerCommonTransform3D.prototype.rotate = function (arad, x, y, z) {
  var M = Matrix.Rotation(arad, $V([x, y, z])).ensure4x4();

  return new Sculpteo3DViewerCommonTransform3D(M.x(this.matrix));
};

Sculpteo3DViewerCommonTransform3D.prototype.inverse = function () {
  return new Sculpteo3DViewerCommonTransform3D(this.matrix._inverse4x4());
};

Sculpteo3DViewerCommonTransform3D.prototype.transpose = function () {
  return new Sculpteo3DViewerCommonTransform3D(this.matrix.transpose());
};

Sculpteo3DViewerCommonTransform3D.prototype.x = function (t) {
  if (t.length == 4) {
    return this.matrix.x($V(t)).flatten();
  }

  return new Sculpteo3DViewerCommonTransform3D(this.matrix.x(t.matrix));
};

Sculpteo3DViewerCommonTransform3D.prototype.transformVect = function (v) {
  var M = this.matrix;

  return [
    M.e(1, 1) * v[0] + M.e(1, 2) * v[1] + M.e(1, 3) * v[2] + M.e(1, 4) * v[3],
    M.e(2, 1) * v[0] + M.e(2, 2) * v[1] + M.e(2, 3) * v[2] + M.e(2, 4) * v[3],
    M.e(3, 1) * v[0] + M.e(3, 2) * v[1] + M.e(3, 3) * v[2] + M.e(3, 4) * v[3],
    M.e(4, 1) * v[0] + M.e(4, 2) * v[1] + M.e(4, 3) * v[2] + M.e(4, 4) * v[3],
  ];
};

Sculpteo3DViewerCommonTransform3D.prototype.toQuat = function () {
  var m00 = this.matrix.e(1, 1);
  var m01 = this.matrix.e(1, 2);
  var m02 = this.matrix.e(1, 3);
  var m10 = this.matrix.e(2, 1);
  var m11 = this.matrix.e(2, 2);
  var m12 = this.matrix.e(2, 3);
  var m20 = this.matrix.e(3, 1);
  var m21 = this.matrix.e(3, 2);
  var m22 = this.matrix.e(3, 3);
  var tr = m00 + m11 + m22; // Trace
  var S, qw, qx, qy, qz;

  if (tr > 0.0) {
    S = Math.sqrt(1.0 + tr);
    qw = 0.5 * S;
    S = 0.5 / S;
    qx = (m21 - m12) * S;
    qy = (m02 - m20) * S;
    qz = (m10 - m01) * S;
  } else if (m00 > m11 && m00 > m22) {
    S = Math.sqrt(1.0 + m00 - m11 - m22);
    qx = 0.5 * S;
    S = 0.5 / S;
    qw = (m21 - m12) * S;
    qy = (m01 + m10) * S;
    qz = (m02 + m20) * S;
  } else if (m11 > m22) {
    S = Math.sqrt(1.0 + m11 - m00 - m22);
    qy = 0.5 * S;
    S = 0.5 / S;
    qw = (m02 - m20) * S;
    qx = (m01 + m10) * S;
    qz = (m12 + m21) * S;
  } else {
    S = Math.sqrt(1.0 + m22 - m00 - m11);
    qz = 0.5 * S;
    S = 0.5 / S;
    qw = (m10 - m01) * S;
    qx = (m02 + m20) * S;
    qy = (m12 + m21) * S;
  }

  return [qx, qy, qz, qw];
};

Sculpteo3DViewerCommonTransform3D.prototype.decompose = function () {
  var tr = [this.matrix.e(1, 4), this.matrix.e(2, 4), this.matrix.e(3, 4)];
  var minor = this.matrix.minor(1, 1, 3, 3);
  var scale = Math.pow(Math.abs(minor.det()), 1.0 / 3.0);

  minor = minor.x(1 / scale);
  var trm = new Sculpteo3DViewerCommonTransform3D(minor);
  var rot = trm.toQuat();

  return { tr: tr, scale: scale, rot: rot };
};

Sculpteo3DViewerCommonTransform3D.prototype.removeScale = function () {
  var m = this.matrix.minor(1, 1, 3, 3);
  var scale = Math.pow(Math.abs(m.det()), 1.0 / 3.0);

  m = m.x(1 / scale);
  m = $M([
    [m.e(1, 1), m.e(1, 2), m.e(1, 3), this.matrix.e(1, 4)],
    [m.e(2, 1), m.e(2, 2), m.e(2, 3), this.matrix.e(2, 4)],
    [m.e(3, 1), m.e(3, 2), m.e(3, 3), this.matrix.e(3, 4)],
    [0, 0, 0, 1],
  ]);

  return new Sculpteo3DViewerCommonTransform3D(m);
};

Sculpteo3DViewerCommonTransform3D.prototype.decomposeScale = function () {
  var minor = this.matrix.minor(1, 1, 3, 3);
  var scale = Math.pow(Math.abs(minor.det()), 1.0 / 3.0);

  return scale;
};

Sculpteo3DViewerCommonTransform3D.identity =
  new Sculpteo3DViewerCommonTransform3D();

Sculpteo3DViewerCommonTransform3D.translation = function (x, y, z) {
  return new Sculpteo3DViewerCommonTransform3D().translate(x, y, z);
};

Sculpteo3DViewerCommonTransform3D.scale = function (x, y, z) {
  return new Sculpteo3DViewerCommonTransform3D().scale(x, y, z);
};

Sculpteo3DViewerCommonTransform3D.rotation = function (arad, x, y, z) {
  return new Sculpteo3DViewerCommonTransform3D().rotate(arad, x, y, z);
};

Sculpteo3DViewerCommonTransform3D.prototype.isIdentity = function () {
  return this.matrix.eql(Matrix.I(4));
};

Sculpteo3DViewerCommonTransform3D.quatMult = function (q, r) {
  var t = [];

  t[0] = q[0] * r[0] - q[1] * r[1] - q[2] * r[2] - q[3] * r[3];
  t[1] = q[0] * r[1] + q[1] * r[0] - q[2] * r[3] + q[3] * r[2];
  t[2] = q[0] * r[2] + q[1] * r[3] + q[2] * r[0] - q[3] * r[1];
  t[3] = q[0] * r[3] - q[1] * r[2] + q[2] * r[1] + q[3] * r[0];

  return t;
};

Sculpteo3DViewerCommonTransform3D.vectNormalize = function (v) {
  var size = Math.sqrt(v[0] * v[0] + v[1] * v[1] + v[2] * v[2]);

  return [v[0] / size, v[1] / size, v[2] / size];
};

Sculpteo3DViewerCommonTransform3D.quatConj = function (q) {
  return [q[0], -q[1], -q[2], -q[3]];
};

Sculpteo3DViewerCommonTransform3D.quatAxis = function (q) {
  if (q[0] == 1.0) {
    return null;
  }

  var d = Math.sqrt(1 - q[0] * q[0]);

  return [q[1] / d, q[2] / d, q[3] / d];
};

Sculpteo3DViewerCommonTransform3D.expandBbox = function (b) {
  return [
    [b[0][0], b[0][1], b[0][2], 1],
    [b[1][0], b[0][1], b[0][2], 1],
    [b[1][0], b[1][1], b[0][2], 1],
    [b[0][0], b[1][1], b[0][2], 1],
    [b[0][0], b[0][1], b[1][2], 1],
    [b[1][0], b[0][1], b[1][2], 1],
    [b[1][0], b[1][1], b[1][2], 1],
    [b[0][0], b[1][1], b[1][2], 1],
  ];
};

//I think this corresponds to XZY euler angles in blender
//(rotation should be passed as y,z,x)
Sculpteo3DViewerCommonTransform3D.eulerToQuat = function (h, a, b) {
  h *= Math.PI / 180;
  a *= Math.PI / 180;
  b *= Math.PI / 180;
  var c1, c2, c3, s1, s2, s3;

  c1 = Math.cos(h / 2);
  c2 = Math.cos(a / 2);
  c3 = Math.cos(b / 2);
  s1 = Math.sin(h / 2);
  s2 = Math.sin(a / 2);
  s3 = Math.sin(b / 2);

  return [
    c1 * c2 * c3 - s1 * s2 * s3,
    s1 * s2 * c3 + c1 * c2 * s3,
    s1 * c2 * c3 + c1 * s2 * s3,
    c1 * s2 * c3 - s1 * c2 * s3,
  ];
};

//I think this corresponds to XYZ euler angles in blender
//(rotation should be passed as y,x,z)
Sculpteo3DViewerCommonTransform3D.eulerToQuat2 = function (p, r, y) {
  p *= Math.PI / 180;
  r *= Math.PI / 180;
  y *= Math.PI / 180;
  cy = Math.cos(y * 0.5);
  sy = Math.sin(y * 0.5);
  cr = Math.cos(r * 0.5);
  sr = Math.sin(r * 0.5);
  cp = Math.cos(p * 0.5);
  sp = Math.sin(p * 0.5);

  return [
    cy * cr * cp + sy * sr * sp,
    cy * sr * cp - sy * cr * sp,
    cy * cr * sp + sy * sr * cp,
    sy * cr * cp - cy * sr * sp,
  ];
};

Sculpteo3DViewerCommonTransform3D.buildTransformedBox = function (bbox, mRot) {
  mRot = new Sculpteo3DViewerCommonTransform3D(mRot.toString());
  var ptList = Sculpteo3DViewerCommonTransform3D.expandBbox(bbox);
  var transformedPtList0 = [];
  var transformedPtList1 = [];
  var transformedPtList2 = [];

  ptList.forEach(function (pt) {
    var _pt = mRot.transformVect(pt);
    transformedPtList0.push(_pt[0]);
    transformedPtList1.push(_pt[1]);
    transformedPtList2.push(_pt[2]);
  });

  return [
    [
      Math.min.apply(null, transformedPtList0),
      Math.min.apply(null, transformedPtList1),
      Math.min.apply(null, transformedPtList2),
    ],
    [
      Math.max.apply(null, transformedPtList0),
      Math.max.apply(null, transformedPtList1),
      Math.max.apply(null, transformedPtList2),
    ],
  ];
};
